import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import OnlineRedirectStep from './OnlineRedirectStep';
import styles from './PublicDonation.module.css';
import { DonationFormState, DonationPageConfig } from './types';

interface Props {
  config: DonationPageConfig;
  form: DonationFormState;
  onError: (message: string) => void;
}

const BitPaymentStep = ({ config, form, onError }: Props) => {
  const { t } = useTranslation();
  const [mobilePhone, setMobilePhone] = useState(form.donor.phone.trim());
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    if (!/^05\d{8}$/.test(mobilePhone.trim())) {
      setError(t('donations.validation.phoneRequiredForBit'));
      return;
    }
    setError('');
    setSubmitted(true);
  };

  if (submitted) {
    const formWithMobile: DonationFormState = {
      ...form,
      donor: { ...form.donor, phone: mobilePhone.trim() },
    };
    return <OnlineRedirectStep fundId={config.fundId} form={formWithMobile} paymentType="Bit" onError={onError} />;
  }

  return (
    <div className={styles.section}>
      <h3 className={styles.sectionTitle}>{t('donations.bitMobileTitle')}</h3>
      <div className={styles.field}>
        <input
          className={`${styles.fieldInputLarge} ${error ? styles.fieldInputError : ''}`}
          type="tel"
          dir="ltr"
          value={mobilePhone}
          onChange={(e) => { setMobilePhone(e.target.value); setError(''); }}
        />
        {error && <small className={styles.fieldError} style={{ position: 'static' }}>{error}</small>}
        <button type="button" className={styles.submitBtn} style={{ marginTop: 8 }} onClick={handleSubmit}>
          {t('donations.payNow')}
        </button>
      </div>
    </div>
  );
};

export default BitPaymentStep;
